import { computed } from 'vue';

import {
  hasAtLeastTwoRentals,
  hasAtLeastVehicles,
  hasNoPreviousInsurance,
  hasPreviousInsuranceFromPartner,
  hasPreviousInsuranceVorversicherungVersicherungsnehmer,
  hasRentalCoverage,
  hasRentCoverage,
  hasThreeRentals,
} from '@/features/Sparten/res/formConfigs/sharedRenderConditions';
import { useResInputStore } from '@/features/Sparten/res/useInputStore';
import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';

export const hasNoPartnerWithPreviousInsurance: ConditionalRequestDefinition = {
  if: computed(() => hasPreviousInsuranceFromPartner.value === false),
  drop: [
    'zusaetzlicheAngaben.allgemein.vorversicherungPartner.versicherungsnummer',
    'zusaetzlicheAngaben.allgemein.vorversicherungPartner.gesellschaft',
    'zusaetzlicheAngaben.allgemein.vorversicherungPartner.kuendigender',
  ],
};

export const hasNoPreviousInsuranceVorversicherungVersicherungsnehmer: ConditionalRequestDefinition =
  {
    if: computed(() => !hasNoPreviousInsurance.value),
    drop: ['zusaetzlicheAngaben.allgemein.vorversicherungVersicherungsnehmer'],
  };

export const hasNoPreviousInsuranceVorversicherungVersicherungsnehmerData: ConditionalRequestDefinition =
  {
    if: computed(
      () =>
        hasPreviousInsuranceVorversicherungVersicherungsnehmer.value === false,
    ),
    drop: [
      'zusaetzlicheAngaben.allgemein.vorversicherungVersicherungsnehmer.versicherungsnummer',
      'zusaetzlicheAngaben.allgemein.vorversicherungVersicherungsnehmer.gesellschaft',
      'zusaetzlicheAngaben.allgemein.vorversicherungVersicherungsnehmer.kuendigender',
    ],
  };

export const hasNoRentCoverage: ConditionalRequestDefinition = {
  if: computed(() => !hasRentCoverage.value),
  drop: ['zusaetzlicheAngaben.mieten'],
};

export const hasNoRentalCoverage: ConditionalRequestDefinition = {
  if: computed(() => !hasRentalCoverage.value),
  drop: ['zusaetzlicheAngaben.vermietung'],
};

export const hasNotAtLeastTwoRentals: ConditionalRequestDefinition = {
  if: computed(() => !hasAtLeastTwoRentals.value),
  drop: [
    'zusaetzlicheAngaben.vermietung.vermietungObjektAnschrift1',
    'zusaetzlicheAngaben.vermietung.vermietungObjektAnschrift2',
  ],
};

export const hasNotThreeRentals: ConditionalRequestDefinition = {
  if: computed(() => !hasThreeRentals.value),
  drop: ['zusaetzlicheAngaben.vermietung.vermietungObjektAnschrift2'],
};

export const hasNoVehicleCoverage: ConditionalRequestDefinition = {
  if: computed(() => !useResInputStore().leistungsumfang.verkehr),
  drop: ['zusaetzlicheAngaben.verkehr'],
};

export const vehicleConditions: ConditionalRequestDefinition[] = [];
for (let i = 0; i < 6; i += 1) {
  vehicleConditions.push({
    if: computed(() => !hasAtLeastVehicles(i + 1, i !== 0)),
    drop: [`zusaetzlicheAngaben.verkehr.verkehrFahrzeugKennzeichen${i}`],
  });
}

export const resContractDehydrationDefinitions: ConditionalRequestDefinition[] =
  [
    ...vehicleConditions,
    hasNoPartnerWithPreviousInsurance,
    hasNoPreviousInsuranceVorversicherungVersicherungsnehmer,
    hasNoPreviousInsuranceVorversicherungVersicherungsnehmerData,
    hasNoRentCoverage,
    hasNoRentalCoverage,
    hasNotAtLeastTwoRentals,
    hasNotThreeRentals,
    hasNoVehicleCoverage,
  ];
